import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import useName from "components/lead/LeadLayout/LeadBanner/useName";
import InfoBanner from "components/shared/InfoBanner";
import PageTitle from "components/shared/PageTitle";
import { selectors } from "store";

const LeadBanner: FunctionComponent = function ({}) {
  const name = useName();
  const isLoading = useSelector(selectors.getIsLoading);

  return (
    <>
      <PageTitle>{name}</PageTitle>
      <InfoBanner title={name} isLoading={isLoading} />
    </>
  );
};

export default LeadBanner;
